import React, { useEffect, useState, useRef, useCallback } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'

import { useForm } from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup"


// Hooks
import useWindowSize from './../../../../Hooks/useWindowSize'

// Atom 
// import Button, { ButtonCategory } from './../../../../Components/Atoms/Button'

// Mol
import Modal, { ModalSize } from './../../../../Components/Molecules/Modal'
import MTooltipModal from "./../../../../Components/Molecules/Modal/Part/MTooltip"

// Sass
import './../../../../Sass/includes/Components/modules/perfilador.sass'

const Perfilador2Counter = (props, ref) => {
    const {
        name,
        min,
        max,
        // register,
        //setValue,
        //getValues,
        handleChangeAnswerSelected,
        value,
        idAnsw,
        setContenidoSel,
        contenidoSel
    } = props


    const increment = (e) => {
        const valueOld = contenidoSel.filter(c => c.desc === 'Dispositivos')[0].value
        if(valueOld < 60){
            let valueToIncrement = value && (value >= min && value <= max) ? value : min
            let InputValNum = valueToIncrement + 1
            if (InputValNum <= max) {
                handleChangeAnswerSelected(e, InputValNum)
                const cont = contenidoSel.filter(c => c.desc === 'Dispositivos')[0]
                const newVal = cont.value + 1
                contenidoSel.filter(c => c.desc === 'Dispositivos')[0].value = newVal
                setContenidoSel(contenidoSel)
            }
        }
    }
    const decrement = (e) => {  
        let valueToDecrement = value && (value >= min && value <= max) ? value : min
        let InputValNum = valueToDecrement - 1
        if (InputValNum >= min) {
            console.log("decrement", InputValNum)
            handleChangeAnswerSelected(e, InputValNum)
            const cont = contenidoSel.filter(c => c.desc === 'Dispositivos')[0]
            const newVal = cont.value - 1
            contenidoSel.filter(c => c.desc === 'Dispositivos')[0].value = newVal
            setContenidoSel(contenidoSel)
        }
    }
    return (
        <div className="customInputNumber">
            <button className="btnMin" type="button" name={name} value={idAnsw} onClick={(e) => { decrement(e) }}>-</button>
            {/* <input type="number" max={max} min={min} {...register(name)} /> */}
            <input type="number" readOnly max={max} min={min} name={name} value={value && (value >= min && value <= max) ? value : min} />
            <button className="btnMax" type="button" name={name} value={idAnsw} onClick={(e) => { increment(e) }}>+</button>
        </div>
    )
}

Perfilador2Counter.propTypes = {
    // onClick: PropTypes.func,
    name: PropTypes.string.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
    register: PropTypes.func.isRequired,
    //setValue: PropTypes.func.isRequired,
   // getValues: PropTypes.func.isRequired,
}

Perfilador2Counter.defaultProps = {
    name: 'requerido',
    min: 0,
    max: 10,
}

const Perfilador2Form = React.memo((props) => {
    const {
        onSubmit,
        handleChangeCurrentPage,
        nextPage,
        previousPage,
        activePage,
        questionsAnswers,
        handleChangeAnswerSelected,
        setContenidoSel,
        contenidoSel
    } = props

    // Ref
    const cardsRef = useRef([]);

    // hooks
    const {
        width: widthWindos,
        // height: wheightWindos, 
    } = useWindowSize()

    const [maxHeight, setMaxHeight] = useState(0)

    const schemaForm = yup.object().shape({
        structure: yup.string(),

    });

    const { register, handleSubmit, setValue, getValues } = useForm({
        defaultValues: {
            smartphones: 1,
            pcs: 2,
            smartTv: 3,
            videogames: 4,
            devices: 5,
            systems: 6,
        },
        resolver: yupResolver(schemaForm),
    });

    const modalTooltipRef = useRef()
    const openModalTooltip = () => modalTooltipRef.current.open()

    const handleBack = (e) => {
        console.log('Regresar')
        handleChangeCurrentPage(e, null, previousPage)
    }

    const ajustarAlto = useCallback((items) => {
        items.map((item) => item.getElementsByTagName('h4')[0].removeAttribute('style'))
        if (widthWindos < 960) {
            const alturas = items.map((item) => item.getElementsByTagName('h4')[0].offsetHeight)
            setMaxHeight(Math.max(...alturas))
            items.map((item) => item.getElementsByTagName('h4')[0].setAttribute('style', `height: ${maxHeight}px`))

        }
    }, [widthWindos, maxHeight])

    useEffect(() => {
        ajustarAlto(cardsRef.current)
    }, [widthWindos, ajustarAlto])

    const Dispositivos = contenidoSel.find(c => c.desc === 'Dispositivos')
    return (
        <form className="formPerfilador" onSubmit={handleSubmit(onSubmit)}>
            <div className="perfiladorStepsWrap">
                <h3>¿Cuántos dispositivos se conectan al mismo tiempo a internet en tu hogar?</h3>
                <div className="perfStep2Grid">
                    {
                        questionsAnswers[activePage]?.length
                            ?
                            questionsAnswers[activePage].map((ask, index) => (
                                ask?.fi_TIPO === 3
                                    ?
                                    <div className="perfStep2GridElement" key={uuid()} ref={el => cardsRef.current[0] = el}>
                                        <div className="perfStep2GridEleTitle">
                                            <h4>
                                                <strong>{ask.fc_TITULO}</strong>
                                                {
                                                    ask?.fc_DESCRIPCION
                                                        ?
                                                        <span>{ask.fc_DESCRIPCION !== "." ? ask.fc_DESCRIPCION: ""}</span>
                                                        : null
                                                }
                                            </h4>
                                            <i className={ask.fc_CLASE_ICONO}></i>
                                        </div>
                                        {
                                            ask?.perfiladorRespuestas?.length
                                                ?
                                                ask.perfiladorRespuestas.map((answ, index) => (
                                                    <Perfilador2Counter
                                                        key={uuid()}
                                                        register={register}
                                                        max={answ.fi_VALOR_MAXIMO}
                                                        min={answ.fi_VALOR_MINIMO}
                                                        setValue={setValue}
                                                        getValues={getValues}
                                                        name={String(ask.fi_PREGUNTA)}
                                                        handleChangeAnswerSelected={handleChangeAnswerSelected}
                                                        idAnsw={answ.fi_RESPUESTA}
                                                        value={answ?.InputValNum ? answ?.InputValNum : 0}
                                                        setContenidoSel={setContenidoSel}
                                                        contenidoSel={contenidoSel}
                                                    />
                                                ))
                                                :
                                                null
                                        }
                                    </div>
                                    :
                                    null
                            ))
                            :
                            null
                    }
                    {/* <div className="perfStep2GridElement" ref={el => cardsRef.current[0] = el}>
                        <div className="perfStep2GridEleTitle">
                            <h4>
                                <strong>Smartphones y Tablets sd d a dsa d asdasdasd asd as da  dsadasd asd  ds asd sd asd asd as dsa das dasd sa dasd as dsa das das da da das d</strong>
                            </h4>
                            <i className="cIco-smartphones"></i>
                        </div> 
                        <Perfilador2Counter
                            register={register}
                            max={2000}
                            setValue={setValue}
                            getValues={getValues}
                            name='smartphones'
                        />*/}
                    {/* <div className="customInputNumber">
                            <button className="btnMin" type="button">-</button>
                            <input type="number" max="2000" min="0" value="0" {...register("smartphones")}/>
                            <button className="btnMax" type="button">+</button>
                        </div> */}
                    {/* </div> */}
                    {/* <div className="perfStep2GridElement" ref={el => cardsRef.current[1] = el}>
                        <div className="perfStep2GridEleTitle">
                            <h4>
                                <strong>Computadoras</strong>
                                <span> (escritorio y portátiles)</span>
                            </h4>
                            <i className="cIco-computadoras"></i>
                        </div>
                        <Perfilador2Counter
                            register={register}
                            max={2000}
                            setValue={setValue}
                            getValues={getValues}
                            name='pcs'
                        />
                    </div> */}
                    {/* <div className="perfStep2GridElement" ref={el => cardsRef.current[2] = el}>
                        <div className="perfStep2GridEleTitle">
                            <h4>
                                <strong>Smart TV y reproductores multimedia</strong>
                                <span> (Amazón, Fire stick, Apple tv, Chromecast, Roku y otros)</span>
                            </h4>
                            <i className="cIco-smart-tv"></i>
                        </div>
                        <Perfilador2Counter
                            register={register}
                            max={2000}
                            setValue={setValue}
                            getValues={getValues}
                            name='smartTv'
                        />
                    </div>
                    <div className="perfStep2GridElement" ref={el => cardsRef.current[3] = el}>
                        <div className="perfStep2GridEleTitle">
                            <h4>
                                <strong>Consolas de Videojuegos</strong>
                            </h4>
                            <i className="cIco-videojuegos"></i>
                        </div>
                        <Perfilador2Counter
                            register={register}
                            max={2000}
                            setValue={setValue}
                            getValues={getValues}
                            name='videogames'
                        />
                    </div> */}
                    {/* <div className="perfStep2GridElement" ref={el => cardsRef.current[4] = el}>
                        <div className="perfStep2GridEleTitle">
                            <h4>
                                <strong>Dispositivos inteligentes </strong>
                                <span> (Alexa, Google Home, Apple HomePod, otros)</span>
                            </h4>
                            <i className="cIco-casa-inteligente"></i>
                        </div>
                        <Perfilador2Counter
                            register={register}
                            max={2000}
                            setValue={setValue}
                            getValues={getValues}
                            name='devices'
                        />
                    </div>
                    <div className="perfStep2GridElement" ref={el => cardsRef.current[5] = el}>
                        <div className="perfStep2GridEleTitle">
                            <h4>
                                <strong>Sistemas de vigilancia</strong>
                                <span> (Cámaras, alarmas)</span>
                            </h4>
                            <i className="cIco-vigilancia"></i>
                        </div>
                        <Perfilador2Counter
                            register={register}
                            max={2000}
                            setValue={setValue}
                            getValues={getValues}
                            name='systems'
                        />
                    </div> */}
                </div>
            </div>
            <div className="perfiladorBtns perfBtn02">
                {/* <Button
                    category={ButtonCategory.TRANS_GRIS}
                    onClick={() => handleBack()}
                >
                    Regresar
                </Button> */}
                <button className='btn btnTransGris' type='button' value='Perfilador1Org' onClick={handleBack}>
                    Regresar
                </button>
                {
                    Dispositivos?.value
                    ?
                    <button className='btn btnPrimario' type='button' value='Perfilador3Org' onClick={(e) => { handleChangeCurrentPage(e, null, nextPage) }}>
                        Continuar
                    </button>
                    :
                    <button className='btn btnPrimario' type='button' value='Perfilador3Org' onClick={(e) => { openModalTooltip() }}>
                        Continuar
                    </button>
                }

            </div>
            <Modal
                ref={modalTooltipRef}
                size={ModalSize.SMALL}
            >
                <MTooltipModal
                
                activePage={activePage}

                />
            </Modal>
        </form>
    )
})

Perfilador2Form.propTypes = {
    onSubmit: PropTypes.func,
}

function Perfilador2PeopleOrg(props) {
    const {
        handleChangeCurrentPage,
        sections,
        activePage,
        questionsAnswers,
        handleChangeAnswerSelected,
        setContenidoSel,
        contenidoSel
    } = props

    const onSubmitForm = data => {
        console.log('Submit:', data);
    }
    const perfiladorSteps = sections?.length ? sections.map((item, index) => (
        <li key={uuid()} className={index === activePage ? "current" : index <= activePage ? "done" : ""}>

            <span>
                <i>{index + 1}</i>
            </span>
            <strong>{item.fc_TITULO}</strong>
        </li>
    )) : null
    // function nextPage(){
    //     const cont = contenidoSel.filter(c => c.desc === 'Dispositivos')[0]
    //     if(cont.value === 0){
    //         return activePage + 2
    //     }
    //     return activePage + 1
    // }
    return (
        <section className="light">
            <div className="container">
                <div className="perfiladorTitle">
                    <h2>Asesor de Experiencia y Velocidad Wifi</h2>
                    <p>Con nuestro asesor de velocidad de Internet Fijo puedes calcular con mayor exactitud el plan que necesitas en tu hogar.</p>
                </div>
                <ul className="perfiladorSteps">
                    {perfiladorSteps}
                    {/* <li className="done">
                        <span>
                            <i>1</i>
                        </span>
                        <strong>Tu Hogar</strong>
                    </li>
                    <li className="current">
                        <span>
                            <i>2</i>
                        </span>
                        <strong>Tus Dispositivos</strong>
                    </li>
                    <li>
                        <span>
                            <i>3</i>
                        </span>
                        <strong>Tus Necesidades</strong>
                    </li> */}
                </ul>
                <Perfilador2Form
                    onSubmit={onSubmitForm}
                    handleChangeCurrentPage={handleChangeCurrentPage}
                    sections={sections}
                    activePage={activePage}
                    // nextPage={nextPage()}
                    nextPage={activePage + 1}
                    previousPage={activePage - 1}
                    questionsAnswers={questionsAnswers}
                    handleChangeAnswerSelected={handleChangeAnswerSelected}
                    setContenidoSel={setContenidoSel}
                    contenidoSel={contenidoSel}
                />
            </div>
        </section>
    )
}

export default Perfilador2PeopleOrg
